<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <form
      autocomplete="off"
      method="post"
      @submit.prevent="addRequestServicesReservation"
    >
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-3 col-lg-3">
            <b-form-select
              v-model="servicesReservationData.branchToken"
              :options="branchTokenOptions"
              @change="filterOfficesTimes()"
              class="form-control"
            ></b-form-select>
            <img src="@/assets/images/branches.svg" />
          </div>
          <div class="col-md-6 col-lg-3 client-add">
            <CustomSelectBoxWithImg
              :className="'col-md-11'"
              :id="'clientToken'"
              :value="servicesReservationData.clientToken"
              :options="clientTokenOptions"
              v-on:changeValue="clientChanged($event)"
              :title="$t('selectClient')"
              :imgName="'clients.svg'"
              :isSync="true"
              v-on:synchronization="getDialogOfClientsWithImage()"
            />
            <button
              v-b-modal.ServicesReservationAddClient
              class="btn p-0"
              @click.prevent=""
              :title="$t('addClient')"
            >
              <img src="@/assets/images/plus.svg" class="icon-lg" />
            </button>
          </div>

          <DatePicker
            :className="'col-md-6 col-lg-3'"
            :id="'reservationDate'"
            :value="servicesReservationData.reservationDate"
            v-on:changeValue="changeReservationDate($event)"
            :title="$t('reservationDate')"
            :language="language"
          />
          <div class="form-label-group col-md-6 col-lg-3">
            <b-form-select
              v-model="servicesReservationData.specialSpecialtyToken"
              :options="specialSpecialtyTokenOptions"
              @change="changeSpecialSpecialty()"
              class="form-control"
            ></b-form-select>
            <img src="@/assets/images/special-spcialities.svg" />
          </div>

          <CustomSelectBoxWithImg
            :className="'col-md-12'"
            :id="'serviceToken'"
            :value="servicesReservationData.serviceToken"
            :options="serviceTokenOptions"
            v-on:changeValue="servicesReservationData.serviceToken = $event"
            :title="$t('selectService')"
            :imgName="'services.svg'"
            :isSync="true"
            v-on:synchronization="getDialogOfServicesWithImage()"
          />
          <CustomSelectBox
            :className="'col-md-6'"
            :id="'reservationTypeToken'"
            :value="servicesReservationData.reservationTypeToken"
            :options="reservationTypeTokenOptions"
            v-on:changeValue="reservationTypeChanged($event)"
            :title="$t('selectReservationType')"
            :imgName="'type.svg'"
          />
          <CustomSelectBox
            :className="'col-md-6'"
            :id="'offerCode'"
            :value="servicesReservationData.offerCode"
            :options="offerCodeOptions"
            v-on:changeValue="servicesReservationData.offerCode = $event"
            :title="$t('selectOffer')"
            :imgName="'offers.svg'"
          />

          <CustomSelectBox
            v-if="
              servicesReservationData.reservationTypeToken ==
              reservationTypes.followingReservation
            "
            :className="'col-md-12'"
            :id="'followToreseRvationToken'"
            :value="servicesReservationData.followToreseRvationToken"
            :options="reservationTokenOptions"
            v-on:changeValue="
              servicesReservationData.followToreseRvationToken = $event
            "
            :title="$t('selectReservation')"
            :imgName="'services-reservations.svg'"
          />
        </div>
      </div>

      <b-button v-b-toggle.reservationTimes class="btn btn-lg btn-collapse">
        {{ $t("reservationTimes") }}
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </b-button>
      <b-collapse id="reservationTimes">
        <div class="my-card">
          <CustomRadio
            :className="'col-md-12'"
            :id="'officeTimeToken'"
            :value="servicesReservationData.officeTimeToken"
            :title="$t('selectReservationTime')"
            :options="officeTimeTokenOptions"
            v-on:changeValue="servicesReservationData.officeTimeToken = $event"
          />

          <TextArea
            :className="'col-md-12'"
            :id="'reservationRequestNotes'"
            :value="servicesReservationData.reservationRequestNotes"
            :title="$t('notes')"
            :imgName="'notes.svg'"
            v-on:changeValue="
              servicesReservationData.reservationRequestNotes = $event
            "
          />
        </div>
      </b-collapse>

      <div
        v-if="
          checkPrivilege(
            usersPrivilegeData.usersPrivilegeServicesReservations
              .servicesReservationAddPay
          )
        "
      >
        <b-button v-b-toggle.paymentData class="btn btn-lg btn-collapse">
          {{ $t("paymentData") }}
          <i class="fa fa-angle-down" aria-hidden="true"></i>
        </b-button>
        <b-collapse id="paymentData">
          <div class="my-card">
            <div class="row">
              <CustomSelectBox
                :className="'col-md-12'"
                :id="'treasuryToken'"
                :value="
                  servicesReservationData.servicesReservationPayData
                    .treasuryToken
                "
                :options="treasuryTokenOptions"
                v-on:changeValue="
                  servicesReservationData.servicesReservationPayData.treasuryToken =
                    $event
                "
                :title="$t('selectTreasury')"
                :imgName="'treasuries.svg'"
              />

              <CustomSelectBox
                :className="'col-md-6'"
                :id="'feesTypeToken'"
                :value="servicesReservationData.feesTypeToken"
                :options="feesTypeTokenOptions"
                v-on:changeValue="
                  servicesReservationData.feesTypeToken = $event
                "
                :title="$t('selectFeesType')"
                :imgName="'type.svg'"
              />
              <CustomInputFloat
                :className="'col-md-6'"
                :id="'feesTypeValue'"
                :value="servicesReservationData.feesTypeValue"
                :title="$t('feesValue')"
                :imgName="'money.svg'"
                v-on:changeValue="
                  servicesReservationData.feesTypeValue = $event
                "
              />

              <CustomSelectBox
                :className="'col-md-6'"
                :id="'methodPaidToken'"
                :value="
                  servicesReservationData.servicesReservationPayData
                    .methodPaidToken
                "
                :options="methodPaidTokenOptions"
                v-on:changeValue="
                  servicesReservationData.servicesReservationPayData.methodPaidToken =
                    $event
                "
                :title="$t('selectMethodPaid')"
                :imgName="'payment-method.svg'"
              />
              <CustomInputFloat
                :className="'col-md-6'"
                :id="'methodPaidValue'"
                :value="
                  servicesReservationData.servicesReservationPayData
                    .methodPaidValue
                "
                :title="$t('paidMoney')"
                :imgName="'money.svg'"
                v-on:changeValue="
                  servicesReservationData.servicesReservationPayData.methodPaidValue =
                    $event
                "
              />

              <TextArea
                :className="'col-md-12'"
                :id="'payNote'"
                :value="
                  servicesReservationData.servicesReservationPayData.payNote
                "
                :title="$t('notes')"
                :imgName="'notes.svg'"
                v-on:changeValue="
                  servicesReservationData.servicesReservationPayData.payNote =
                    $event
                "
              />
            </div>
          </div>
        </b-collapse>
      </div>

      <div class="form-footer">
        <button name="submit" type="submit" class="btn btn-submit">
          {{ submitName }}
        </button>
        <router-link to="/services-reservations" class="btn btn-cancel">
          {{ $t("cancel") }}
        </router-link>
      </div>
    </form>

    <ServicesReservationAddClient
      v-on:clientAdded="getDialogOfClientsWithImage()"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
// import axios from "axios";
import DatePicker from "@/components/general/DatePicker.vue";
import CustomInputFloat from "@/components/general/CustomInputFloat.vue";
import CustomRadio from "@/components/general/CustomRadio.vue";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import CustomSelectBoxWithImg from "@/components/general/CustomSelectBoxWithImg.vue";
import TextArea from "@/components/general/TextArea.vue";
// import DataLabelGroup from "@/components/general/DataLabelGroup.vue";
import { STATUS } from "@/utils/constants";
import { RESERVATION_TYPES } from "@/utils/constantLists";
import {
  setDataMultiLang,
  checkPrivilege,
  getDayTokenOfDate,
} from "@/utils/functions";
import axios from "axios";
import Branch from "@/models/branches/Branch";
import Client from "@/models/clients/Client";
import GeneralSpecialty from "@/models/settings/settingsOther/generalSpecialties/GeneralSpecialty";
import SpecialSpecialty from "@/models/settings/settingsOther/specialSpecialties/SpecialSpecialty";
import ServicesType from "@/models/settings/settingsOther/servicesTypes/ServicesType";
import Service from "@/models/settings/settingsOther/services/Service";
import Offer from "@/models/offers/Offer";
import Treasury from "@/models/finance/treasuries/Treasury";
import MethodPaid from "@/models/settings/settingsOther/methodPaids/MethodPaid";
import OfficeTime from "@/models/settings/settingsBranch/officesTimes/OfficeTime";
import ServicesReservation from "@/models/servicesReservations/ServicesReservation";
import UserPrivilege from "@/models/privileges/UserPrivilege";
import createToastMixin from "@/utils/create-toast-mixin";
import ServicesReservationAddClient from "@/components/servicesReservations/ServicesReservationAddClient.vue";

export default {
  name: "ServicesReservationForm",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    DatePicker,
    CustomInputFloat,
    CustomRadio,
    CustomSelectBoxWithImg,
    CustomSelectBox,
    ServicesReservationAddClient,
    TextArea,
    // DataLabelGroup,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      usersPrivilegeData:
        this.$store.getters.userData.usersPrivilegeData || new UserPrivilege(),
      clientData: new Client(),
      clientTokenOptions: [],
      generalSpecialtyData: new GeneralSpecialty(),
      generalSpecialtyTokenOptions: [],
      specialSpecialtyData: new SpecialSpecialty(),
      specialSpecialtyTokenOptions: [],
      servicesTypeData: new ServicesType(),
      serviceTypeTokenOptions: [],
      serviceData: new Service(),
      serviceTokenOptions: [],
      branchData: new Branch(),
      branchTokenOptions: [],
      officeTimeData: new OfficeTime(),
      officeTimeTokenOptions: [],
      offerCodeData: new Offer(),
      offerCodeOptions: [],
      feesTypeTokenOptions: [],
      treasuryData: new Treasury(),
      treasuryTokenOptions: [],
      methodPaidData: new MethodPaid(),
      methodPaidTokenOptions: [],
      dayTokenOptions: [],
      reservationData: new ServicesReservation(),
      reservationTokenOptions: [],
      reservationTypeTokenOptions: [],
      reservationTypes: RESERVATION_TYPES,
    };
  },
  props: ["servicesReservationData", "submitName"],
  methods: {
    async addRequestServicesReservation() {
      this.$emit("addRequestServicesReservation");
    },
    async changeGeneralSpecialty() {
      this.servicesReservationData.specialSpecialtyToken = "";
      this.servicesReservationData.serviceToken = "";
      this.servicesReservationData.servicePrice = "";
      this.servicesReservationData.serviceTimeWithMinutes = "";
      this.servicesReservationData.maxDiscountPercentage = "";
      this.getDialogOfSpecialSpecialties();
      this.getDialogOfServicesWithImage();
      this.getDialogOfOfficesTimes();
    },
    async changeSpecialSpecialty() {
      this.servicesReservationData.serviceToken = "";
      this.servicesReservationData.servicePrice = "";
      this.servicesReservationData.serviceTimeWithMinutes = "";
      this.servicesReservationData.maxDiscountPercentage = "";
      this.getDialogOfServicesWithImage();
      this.getDialogOfOfficesTimes();
    },
    async changeServiceType() {
      this.servicesReservationData.serviceToken = "";
      this.servicesReservationData.servicePrice = "";
      this.servicesReservationData.serviceTimeWithMinutes = "";
      this.servicesReservationData.maxDiscountPercentage = "";
      this.getDialogOfServicesWithImage();
    },
    async filterOfficesTimes() {
      this.servicesReservationData.officeTimeToken = "";
      this.getDialogOfOfficesTimes();
    },
    async changeReservationDate(date) {
      this.servicesReservationData.reservationDate = date;
      this.servicesReservationData.dayToken = this.getDayTokenOfDate(date);
      this.filterOfficesTimes();
      this.servicesReservationData.offerCode = "";
      this.getDialogOfOfferCodes();
    },
    async getDialogOfGeneralSpecialties() {
      this.isLoading = true;
      this.generalSpecialtyTokenOptions = [];
      this.generalSpecialtyTokenOptions.push({
        value: "",
        text: this.$t("selectGeneralSpecialty"),
      });
      try {
        let response =
          await this.generalSpecialtyData.getDialogOfGeneralSpecialties(
            this.language,
            this.userAuthorizeToken
          );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.generalSpecialtyTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfSpecialSpecialties() {
      this.isLoading = true;
      this.specialSpecialtyTokenOptions = [];
      this.specialSpecialtyTokenOptions.push({
        value: "",
        text: this.$t("selectSpecialSpecialty"),
      });
      try {
        let response = await axios.get(
          `/SpecialSpecialties/GetDialogOfSpecialSpecialties?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}&filterStatus=true&generalSpecialtyToken=${this.servicesReservationData.generalSpecialtyToken}`
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.specialSpecialtyTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfServicesTypes() {
      this.isLoading = true;
      this.serviceTypeTokenOptions = [];
      this.serviceTypeTokenOptions.push({
        value: "",
        text: this.$t("selectServiceType"),
      });
      try {
        let response = await this.servicesTypeData.getDialogOfServicesTypes(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.serviceTypeTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfServicesWithImage() {
      this.isLoading = true;
      this.serviceData.specialSpecialtyToken =
        this.servicesReservationData.specialSpecialtyToken;

      try {
        this.serviceTokenOptions =
          await this.serviceData.getDialogOfServicesWithImage(
            this.language,
            this.userAuthorizeToken
          );
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfOfficesTimes() {
      this.isLoading = true;
      this.officeTimeData.dayToken = this.servicesReservationData.dayToken;
      this.officeTimeData.branchToken =
        this.servicesReservationData.branchToken;
      this.officeTimeData.generalSpecialtyToken =
        this.servicesReservationData.generalSpecialtyToken;
      this.officeTimeData.specialSpecialtyToken =
        this.servicesReservationData.specialSpecialtyToken;
      this.officeTimeTokenOptions = [];
      try {
        let response = await this.officeTimeData.getDialogOfOfficesTimes(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.officeTimeTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        } else {
          this.officeTimeTokenOptions.push({
            value: "",
            text: response.data.msg,
          });
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.officeTimeTokenOptions.push({
          value: "",
          text: this.$t("notFound"),
        });
      }
      this.isLoading = false;
    },
    async getDialogOfDays() {
      this.isLoading = true;
      this.dayTokenOptions = [];
      this.dayTokenOptions.push({
        value: "",
        text: this.$t("selectDay"),
      });
      let days = this.$store.getters.userData.constantLists.listDaysOfWeekData;
      for (let item in days) {
        this.dayTokenOptions.push({
          value: days[item]["itemToken"],
          text: this.setDataMultiLang(
            this.language,
            days[item]["itemNameAr"],
            days[item]["itemNameEn"]
          ),
        });
      }
      this.isLoading = false;
    },
    async getDialogOfBranches() {
      this.isLoading = true;
      this.branchTokenOptions = [];
      this.branchTokenOptions.push({
        value: "",
        text: this.$t("selectBranch"),
      });
      try {
        let response = await this.branchData.getDialogOfBranches(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.branchTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfClientsWithImage() {
      this.isLoading = true;
      try {
        this.clientTokenOptions =
          await this.clientData.getDialogOfClientsWithImage(
            this.language,
            this.userAuthorizeToken
          );
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfOffersCodes() {
      this.isLoading = true;
      this.offerCodeOptions = [];
      this.offerCodeOptions.push({
        value: "",
        text: this.$t("selectOfferCode"),
      });
      this.isLoading = false;
    },
    async getDialogOfFeesTypes() {
      this.isLoading = true;
      this.feesTypeTokenOptions = [];
      this.feesTypeTokenOptions.push({
        value: "",
        text: this.$t("selectFeesType"),
      });
      let items = this.$store.getters.userData.constantLists.listFeesType;
      for (let item in items) {
        this.feesTypeTokenOptions.push({
          value: items[item]["itemToken"],
          text: this.setDataMultiLang(
            this.language,
            items[item]["itemNameAr"],
            items[item]["itemNameEn"]
          ),
        });
      }
      this.isLoading = false;
    },
    async getDialogOfOfferCodes() {
      this.isLoading = true;
      this.offerCodeData.dateActive =
        this.servicesReservationData.reservationDate;
      try {
        this.offerCodeOptions = await this.offerCodeData.getDialogOfOfferCodes(
          this.language,
          this.userAuthorizeToken
        );
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfTreasuries() {
      this.isLoading = true;
      try {
        this.treasuryTokenOptions =
          await this.treasuryData.getDialogOfTreasuries(
            this.language,
            this.userAuthorizeToken
          );
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfMethodPaid() {
      this.isLoading = true;
      this.methodPaidTokenOptions = [];
      this.methodPaidTokenOptions.push({
        value: "",
        text: this.$t("selectMethodPaid"),
      });
      try {
        let response = await this.methodPaidData.getDialogOfMethodPaid(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.methodPaidTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfServicesReservations() {
      this.isLoading = true;
      this.reservationTokenOptions = [];
      this.reservationTokenOptions.push({
        value: "",
        text: this.$t("selectReservation"),
      });
      this.reservationData.clientToken =
        this.servicesReservationData.clientToken;
      try {
        let response =
          await this.reservationData.getDialogOfServicesReservations(
            this.language,
            this.userAuthorizeToken
          );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.reservationTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfServicesReservationTypes() {
      this.isLoading = true;
      this.reservationTypeTokenOptions = [];
      this.reservationTypeTokenOptions.push({
        value: "",
        text: this.$t("selectReservationType"),
      });
      let items =
        this.$store.getters.userData.constantLists.listServicesReservationType;
      for (let item in items) {
        this.reservationTypeTokenOptions.push({
          value: items[item]["itemToken"],
          text: this.setDataMultiLang(
            this.language,
            items[item]["itemNameAr"],
            items[item]["itemNameEn"]
          ),
        });
      }
      this.isLoading = false;
    },
    reservationTypeChanged(data) {
      this.servicesReservationData.reservationTypeToken = data;
      this.servicesReservationData.followToreseRvationToken = "";
      if (
        this.servicesReservationData.reservationTypeToken ==
        RESERVATION_TYPES.followingReservation
      )
        this.getDialogOfServicesReservations();
    },
    clientChanged(data) {
      this.servicesReservationData.clientToken = data;
      this.servicesReservationData.followToreseRvationToken = "";
      if (
        this.servicesReservationData.reservationTypeToken ==
        RESERVATION_TYPES.followingReservation
      )
        this.getDialogOfServicesReservations();
    },
    checkPrivilege(privilegeStatus) {
      return checkPrivilege(privilegeStatus);
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      return setDataMultiLang(lang, dataAr, dataEn);
    },
    getDayTokenOfDate(date) {
      return getDayTokenOfDate(date);
    },
  },
  watch: {},
  async created() {
    this.reservationData.reservationTypeToken =
      RESERVATION_TYPES.mainReservation;
    this.getDialogOfGeneralSpecialties();
    this.getDialogOfSpecialSpecialties();
    this.getDialogOfServicesTypes();
    this.getDialogOfServicesWithImage();
    this.getDialogOfOfficesTimes();
    this.getDialogOfDays();
    this.getDialogOfBranches();
    this.getDialogOfClientsWithImage();
    this.getDialogOfOffersCodes();
    this.getDialogOfFeesTypes();
    this.getDialogOfOfferCodes();
    this.getDialogOfTreasuries();
    this.getDialogOfMethodPaid();
    this.getDialogOfServicesReservationTypes();
    this.getDialogOfServicesReservations();
  },
};
</script>

<style lang="scss"></style>
